document.addEventListener('DOMContentLoaded', () => {

  // --- Smooth scroll with offset for hash links ---
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      if (e.defaultPrevented) return;
      e.preventDefault();
      const offset = 380;
      const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
      window.history.pushState(null, null, href);
    });
  });

  // --- Splash screen ---
  const splash = document.getElementById('MiraSplash');
  if (splash) {
    splash.addEventListener('animationend', () => splash.remove());
  }

  // --- Burger menu ---
  const burger = document.querySelector('[data-mira-burger]');
  const mobileNav = document.querySelector('[data-mira-nav-mobile]');
  const burgerClose = document.querySelector('[data-mira-burger-close]');

  function openMenu() {
    mobileNav.classList.add('is-open');
    burger.classList.add('is-active');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileNav.classList.remove('is-open');
    burger.classList.remove('is-active');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger && mobileNav) {
    burger.addEventListener('click', openMenu);
    if (burgerClose) burgerClose.addEventListener('click', closeMenu);

    mobileNav.querySelectorAll('.mira-nav-mobile__links a').forEach(a => {
      a.addEventListener('click', closeMenu);
    });

  }

  // --- Header hide on scroll down ---
  const header = document.getElementById('MiraHeader');
  if (header) {
    let lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > lastY && y > 100) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastY = y;
    }, { passive: true });
  }

  // --- Reveal on scroll (Intersection Observer) ---
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    reveals.forEach(el => observer.observe(el));
  }

  // --- Preparation timeline scroll animation ---
  const timeline = document.getElementById('MiraTimeline');
  if (timeline) {
    const steps = timeline.querySelectorAll('.preparation-step');
    const lineFill = timeline.querySelector('.preparation-timeline__line-fill');
    const totalLine = timeline.querySelector('.preparation-timeline__line');

    const updateTimeline = () => {
      const windowMid = window.scrollY + window.innerHeight * 0.55;
      let lastActive = -1;

      steps.forEach((step, i) => {
        const rect = step.getBoundingClientRect();
        const stepMid = rect.top + window.scrollY + rect.height / 2;
        if (stepMid < windowMid) {
          step.classList.add('is-active');
          lastActive = i;
        } else {
          step.classList.remove('is-active');
        }
      });

      if (lineFill && steps.length >= 3) {
        const timelineRect = timeline.getBoundingClientRect();
        const firstRect = steps[0].getBoundingClientRect();
        const stopRect = steps[3].getBoundingClientRect();

        const lineTop = firstRect.top + 20 - timelineRect.top;
        const lineStop = stopRect.top + 20 - timelineRect.top;

        lineFill.style.top = lineTop + 'px';
        totalLine.style.top = lineTop + 'px';
        totalLine.style.height = (lineStop - lineTop) + 'px';

        if (lastActive < 0) {
          lineFill.style.height = '0';
        } else {
          const activeRect = steps[Math.min(lastActive, 3)].getBoundingClientRect();
          const activeMid = activeRect.top + 20 - timelineRect.top;
          const fillHeight = Math.min(activeMid - lineTop, lineStop - lineTop);
          lineFill.style.height = Math.max(0, fillHeight) + 'px';
        }
      }
    };

    window.addEventListener('scroll', updateTimeline, { passive: true });
    updateTimeline();
  }

  // --- Ajax Add to Cart ---
  function updateCartCount(count) {
    ['MiraCartCount', 'MiraCartCountMobile'].forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
      el.classList.add('bump');
      setTimeout(() => el.classList.remove('bump'), 300);
    });
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.col-card__form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      });
      if (res.ok) {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        setTimeout(() => { btn.disabled = false; btn.innerHTML = originalHTML; }, 1200);
      }
    } catch {
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    }
  });

  // --- Collection card variant pills ---
  document.querySelectorAll('.col-card').forEach(card => {
    const pills = card.querySelectorAll('.col-card__variant-pill');
    const input = card.querySelector('.col-card__variant-input');
    const priceEl = card.querySelector('.col-card__price');
    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        if (input) input.value = pill.dataset.variantId;
        if (priceEl && pill.dataset.variantPrice) priceEl.textContent = pill.dataset.variantPrice;
      });
    });
  });

  // --- Benefits title word animation ---
  const benefitsTitle = document.querySelector('.benefits-section__title');
  if (benefitsTitle) {
    const text = benefitsTitle.textContent.trim();
    benefitsTitle.innerHTML = text.split(' ').map(w => `<span class="word">${w}</span>`).join(' ');
    const titleObserver = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { benefitsTitle.classList.add('words-visible'); titleObserver.disconnect(); }
      });
    }, { threshold: 0.3 });
    titleObserver.observe(benefitsTitle);
  }

  // --- Benefits timeline scroll animation ---
  const benefitsTimeline = document.getElementById('MiraBenefitsTimeline');
  if (benefitsTimeline) {
    const bSteps = benefitsTimeline.querySelectorAll('.benefit-step');
    const bLineFill = benefitsTimeline.querySelector('.benefits-timeline__line-fill');
    const bTotalLine = benefitsTimeline.querySelector('.benefits-timeline__line');

    const updateBenefits = () => {
      const windowMid = window.scrollY + window.innerHeight * 0.55;
      let lastActive = -1;

      bSteps.forEach((step) => {
        const rect = step.getBoundingClientRect();
        const stepMid = rect.top + window.scrollY + rect.height / 2;
        if (stepMid < windowMid) {
          step.classList.add('is-active');
          lastActive = Array.from(bSteps).indexOf(step);
        } else {
          step.classList.remove('is-active');
        }
      });

      if (bLineFill && bSteps.length >= 1) {
        const timelineRect = benefitsTimeline.getBoundingClientRect();
        const firstRect = bSteps[0].getBoundingClientRect();
        const stopRect = bSteps[bSteps.length - 1].getBoundingClientRect();

        const lineTop = firstRect.top + 44 - timelineRect.top;
        const lineStop = stopRect.top + 22 - timelineRect.top;

        bLineFill.style.top = lineTop + 'px';
        bTotalLine.style.top = lineTop + 'px';
        bTotalLine.style.height = (lineStop - lineTop) + 'px';

        if (lastActive < 0) {
          bLineFill.style.height = '0';
        } else {
          const activeRect = bSteps[lastActive].getBoundingClientRect();
          const activeMid = activeRect.top + 44 - timelineRect.top;
          const fillHeight = Math.min(activeMid - lineTop, lineStop - lineTop);
          bLineFill.style.height = Math.max(0, fillHeight) + 'px';
        }
      }
    };

    window.addEventListener('scroll', updateBenefits, { passive: true });
    updateBenefits();
  }

  // --- Size toggle (featured collection) ---
  const sizeToggle = document.querySelector('.size-toggle');
  if (sizeToggle) {
    sizeToggle.addEventListener('click', (e) => {
      const btn = e.target.closest('.size-toggle__btn');
      if (!btn) return;
      sizeToggle.querySelectorAll('.size-toggle__btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  }

});
